function filenameFromHeader(header, fallback) {
    if (!header)
        return fallback;
    // `attachment; filename="work-orders.csv"` — grab the quoted name if
    // present, else the bare token.
    const quoted = /filename="([^"]+)"/i.exec(header);
    if (quoted && quoted[1])
        return quoted[1];
    const bare = /filename=([^;]+)/i.exec(header);
    if (bare && bare[1])
        return bare[1].trim();
    return fallback;
}
export const exportsApi = (client) => ({
    /** Download a CSV blob for the requested resource. The caller is
     *  responsible for triggering the actual browser download (or
     *  writing to disk on mobile). */
    download: async (resource) => {
        const res = await client.get(`/api/v1/exports/${resource}`, {
            responseType: 'blob',
        });
        return {
            blob: res.data,
            filename: filenameFromHeader(res.headers['content-disposition'], `${resource}.csv`),
        };
    },
    /** List resolved work orders/tasks matching the given filters, for the
     *  Settings → Data Export "Completion Reports" bulk download. */
    listCompletionReports: (filters) => client.get('/api/v1/exports/completion-reports', { params: filters }).then((r) => r.data),
});
//# sourceMappingURL=exports.js.map